export enum PartnerFormQuestion {
  PARTNER_CONTACT_REASONS = 'partner-contact-reasons',
}
